import Stock from "./StockList";

export default Stock;
